module.exports = __webpack_public_path__ + "img/dpsy-banner.26ecd041.png";